<p-tabs [(value)]="selectedTab">
    <p-tablist>
        <p-tab #me [value]="0">
            <label
                class="clickable"
                [pTooltip]="'product.sales-text-tooltip' | translate"
                [ngClass]="{
                    'font-extrabold': ta1.value,
                    'text-decoration-underline': selectedTab() == me.value()
                }"
                [attr.data-testid]="'formly-product-sales-text-tab'"
            >
                <span class="flex items-center gap-2">
                    {{ 'product.sales-text' | translate }}
                    @if (ta1.value) {
                        <span 
                            class="w-2 h-2 bg-primary-500 rounded-full" 
                            [attr.data-testid]="'formly-product-sales-text-content-indicator'"
                        ></span>
                    }
                </span>
            </label>
        </p-tab>
        <p-tab #me [value]="1">
            <label
                class="clickable"
                [pTooltip]="'product.purchase-text-tooltip' | translate"
                [ngClass]="{
                    'font-extrabold': ta2.value,
                    'text-decoration-underline': selectedTab() == me.value()
                }"
                [attr.data-testid]="'formly-product-purchase-text-tab'"
            >
                <span class="flex items-center gap-2">
                    {{ 'product.purchase-text' | translate }}
                    @if (ta2.value) {
                        <span 
                            class="w-2 h-2 bg-primary-500 rounded-full" 
                            [attr.data-testid]="'formly-product-purchase-text-content-indicator'"
                        ></span>
                    }
                </span>
            </label>
        </p-tab>
        <p-tab #me [value]="2">
            <label
                class="clickable"
                [ngClass]="{
                    'font-extrabold': ta3.value,
                    'text-decoration-underline': selectedTab() == me.value()
                }"
                [attr.data-testid]="'formly-product-dimension-text-tab'"
            >
                <span class="flex items-center gap-2">
                    {{ 'product.dimension-text' | translate }}
                    @if (ta3.value) {
                        <span 
                            class="w-2 h-2 bg-primary-500 rounded-full" 
                            [attr.data-testid]="'formly-product-dimension-text-content-indicator'"
                        ></span>
                    }
                </span>
            </label>
        </p-tab>
        <p-tab #me [value]="3">
            <label
                class="clickable"
                [ngClass]="{
                    'font-extrabold': ta4.value,
                    'text-decoration-underline': selectedTab() == me.value()
                }"
                [attr.data-testid]="'formly-product-information-text-tab'"
            >
                <span class="flex items-center gap-2">
                    {{ 'product.information-text' | translate }}
                    @if (ta4.value) {
                        <span 
                            class="w-2 h-2 bg-primary-500 rounded-full" 
                            [attr.data-testid]="'formly-product-information-text-content-indicator'"
                        ></span>
                    }
                </span>
            </label>
        </p-tab>
        <p-tab #me [value]="4">
            <label
                class="clickable"
                [pTooltip]="'product.info-text-pop-up-tooltip' | translate"
                [ngClass]="{
                    'font-extrabold': ta5.value,
                    'text-decoration-underline': selectedTab() == me.value()
                }"
                [attr.data-testid]="'formly-product-information-text-pop-up-tab'"
            >
                <span class="flex items-center gap-2">
                    {{ 'common.info-pop-up' | translate }}
                    @if (ta5.value) {
                        <span 
                            class="w-2 h-2 bg-primary-500 rounded-full" 
                            [attr.data-testid]="'formly-product-information-text-pop-up-content-indicator'"
                        ></span>
                    }
                </span>
            </label>
        </p-tab>
    </p-tablist>

    <p-tabpanels>
        <p-tabpanel [value]="0">
            <div>
                <textarea
                    pTextarea
                    class="w-full"
                    [class.resize-y]="props?.persistSize"
                    #ta1
                    rows="4"
                    name="salesText"
                    [value]="product?.salesText ?? ''"
                    (input)="onTextChange('salesText', $event.target.value)"
                    [attr.data-testid]="'formly-product-sales-text-textarea'"
                    id="formly-product-sales-text-textarea"
                    [readonly]="props?.disabled"
                ></textarea>
            </div>
        </p-tabpanel>
        <p-tabpanel [value]="1">
            <div>
                <textarea
                    pTextarea
                    class="w-full"
                    [class.resize-y]="props?.persistSize"
                    #ta2
                    rows="4"
                    name="purchase"
                    [value]="product?.purchaseText ?? ''"
                    (input)="onTextChange('purchaseText', $event.target.value)"
                    [attr.data-testid]="'formly-product-purchase-text-textarea'"
                    id="formly-product-purchase-text-textarea"
                ></textarea>
            </div>
        </p-tabpanel>
        <p-tabpanel [value]="2">
            <div>
                <textarea
                    pTextarea
                    class="w-full"
                    [class.resize-y]="props?.persistSize"
                    #ta3
                    rows="4"
                    name="dimension"
                    [value]="product?.dimensionText ?? ''"
                    (input)="onTextChange('dimensionText', $event.target.value)"
                    [attr.data-testid]="'formly-product-dimension-text-textarea'"
                    id="formly-product-dimension-text-textarea"
                ></textarea>
            </div>
        </p-tabpanel>
        <p-tabpanel [value]="3">
            <div>
                <textarea
                    pTextarea
                    class="w-full"
                    [class.resize-y]="props?.persistSize"
                    #ta4
                    rows="4"
                    name="information"
                    [value]="product?.informationText ?? ''"
                    (input)="onTextChange('informationText', $event.target.value)"
                    [attr.data-testid]="'formly-product-information-text-textarea'"
                    id="formly-product-information-text-textarea"
                ></textarea>
            </div>
        </p-tabpanel>
        <p-tabpanel [value]="4">
            <div>
                <textarea
                    pTextarea
                    class="w-full"
                    [class.resize-y]="props?.persistSize"
                    #ta5
                    rows="4"
                    name="info-pop-up"
                    [value]="product?.infoPopUp ?? ''"
                    (input)="onTextChange('infoPopUp', $event.target.value)"
                    [attr.data-testid]="'formly-product-information-text-pop-up-textarea'"
                    id="formly-product-information-text-pop-up-textarea"
                ></textarea>
            </div>
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>
